<div #container [formGroup]="form" class="js-container-amorph-select" [attr.data-type]="type">
  <div #container class="form-group">
    <label for="">
      <span class="label-content">{{ label }}</span>

      @if (type === 'input') {
        <div class="container-icon left-position">
          <input class="form-control js-input" type="text" maxlength="40" [placeholder]="placeholder" [formControlName]="controlName" />

          <button type="button" class="icon" (click)="backToSelect()">
            <span class="material-symbols-outlined"> chevron_left </span>
          </button>
        </div>
      }

      @if (type === 'select') {
        <select class="form-control" [formControlName]="controlName">
          <option value="" disabled selected>{{ 'amorphSelect.selectOption' | cxTranslate }}</option>
          <option value="amorphSelect-input">{{ 'amorphSelect.customValue' | cxTranslate }}</option>
          @for (item of items; track item) {
            <option value="{{ item.code }}">
              {{ item.label }}
            </option>
          }
        </select>
      }

      <cx-form-errors [control]="form.get(controlName)"></cx-form-errors>
    </label>
  </div>
</div>
